module.exports = __webpack_public_path__ + "static/media/pic-global.844dc487.jpg";